// extracted by mini-css-extract-plugin
export default {"headerArrows":"izHNGzR1","arrow":"dsnal3zS","_inactive":"XWK3sLHA"};